import { Accordion, AccordionProps, styled } from '@mui/material';

export const StyledAccordionWrapper = styled('div')(() => ({
  borderRadius: 9,
}));

export const StyledAccordion = styled(Accordion)<AccordionProps>(() => ({
  borderRadius: 9,
}));
